import { DomainRow, norm } from './dedupe';

export function splitTags(x?: string | string[] | null): string[] {
  if (!x) return [];
  return Array.isArray(x)
    ? x.map((t) => t.trim()).filter(Boolean)
    : String(x)
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean);
}

export function uniqueSorted<T>(arr: T[], key: (t: T) => string) {
  const set = new Set<string>();
  const out: T[] = [];
  for (const v of arr) {
    const k = key(v);
    if (!k || set.has(k)) continue;
    set.add(k);
    out.push(v);
  }
  return out.sort((a, b) => key(a).localeCompare(key(b)));
}

// Derive options FROM THE DEDUPED BASE (not filtered list)
export function deriveBundleOptions(base: DomainRow[]) {
  const items = uniqueSorted(
    base.map((r) => ({ value: r.bundle ?? '', label: r.bundle ?? '' })).filter((o) => !!o.value),
    (o) => norm(o.value),
  );
  return [{ value: '', label: 'All bundles' }, ...items];
}

export function deriveTldOptions(base: DomainRow[]) {
  const items = uniqueSorted(
    base.map((r) => ({ value: r.tld ?? '', label: r.tld ?? '' })).filter((o) => !!o.value),
    (o) => norm(o.value),
  );
  return [{ value: '', label: 'All TLDs' }, ...items];
}

export function deriveTagOptions(base: DomainRow[]) {
  const all = base.flatMap((r) => splitTags(r.tags).map((t) => ({ value: t, label: t })));
  const items = uniqueSorted(all, (o) => norm(o.value));
  return items;
}
